
/**
 * @module
 * This is a module that will be called alot on a big form, so for a marginal speed/memory gain, this module is jQuery free.
 * This is a fix for adding responsive behaviour like wrapping a table so it can behave accoring to the same patterna as the regular tables
 */

// We target tables that are of class Dx-Content-Table and .Ge-Table, except if Dx-Ui-Controls-ContentEditor-Table, which is cms editor mode.
const selector = '.Dx-Content-Table';
const tableResponsive = function(el, app) {

    const $el = $(el);
    const $tableParent = $el.parent();

    // we look for the class the class that makes a table weap
    const tableWrapped = $tableParent.hasClass('Ge-Table-Wrap');

    const init = function() {
      // If this is the case, exit.
      if(tableWrapped) {
        return;
      } else {

        // Table is not wrapped, make sure it's not wrapped in the editMode class of "Dx-Ui-Controls-ContentEditor-Table", otherwise cms layout is broken.
        const editorModeTableClass = "Dx-Ui-Controls-ContentEditor-Table";
        if ( $tableParent.hasClass(editorModeTableClass) ) {
          return;
        // Now we can add the wrapper class to make sure the tables scrolls sideways and get correct shadows.
        } else {
          // Adds wrapper and table classes as of the pattern guide -> elements  -> table, basic style 'Ge-Table' applied as well
          // Then wrap in outer to add shadows as well.
          // Check for class to not double them since the table might be loaded in the DOM already.
          if (!$el.hasClass('Ge-Table')) {
            $el.addClass('Ge-Table');
          }

          // if (!$el.hasClass('Ge-Table--vertical')) {
          //   $el.addClass('Ge-Table--vertical');
          // }
          
          $el.wrap("<div class='Ge-Table-Wrap-Outer Ge-Table-Wrap-Outer--content-right'><div class='Ge-Table-Wrap Ge-Table-Wrap--white' data-js-table-wrap></div></div>" );
        }
      }

    }

    return {
        init: init()
    };
};

tableResponsive.selector = selector;

export default tableResponsive;
